const notFound = {
  title: 'الصفحة غير موجودة',
  description: 'الصفحة التي تبحث عنها غير موجودة أو ليس لديك صلاحية الوصول إليها.',
  goBack: 'العودة',
  home: 'الرئيسية',
};

export default notFound;